import { parseTicker } from '@/lib/kalshiTicker';

// Coarse market kind: spread and total classify from the parsed ticker;
// EVERYTHING else (game moneylines, advance, series, props, poly tokens)
// returns 'moneyline'. The Value Dashboard routes focused deep links on this
// catch-all, so do not narrow it. The Position Tracker's filter chips use the
// finer ./trackerMarketFamily contract instead (#980).
export type MarketKind = 'moneyline' | 'spread' | 'total';

/**
 * Classify a ticker into its market family.
 *
 * Moved here from `index.tsx` by #539 for the same reason the types above were
 * extracted: a SECOND consumer outside Position Tracker now needs it, and
 * importing `index.tsx` to get it would drag a 6k-line view (and an import
 * cycle) behind a pure string classification. The Value Dashboard uses it to
 * decide which board a focused deep link belongs to.
 *
 * `index.tsx` re-exports it, so every existing caller and test is unaffected.
 *
 * Reads structured `spread`/`total` info first, then the category suffix as the
 * fallback for outcomes the sport parsers recognize but don't fully
 * destructure — which is why CFB's `cfb-spread` / `cfb-total` categories (#532)
 * classify correctly with no CFB-specific case here.
 *
 * Exported for tests.
 */
export function marketKindFromTicker(ticker: string): MarketKind {
  const parsed = parseTicker(ticker);
  // Structured spread/total info first, category suffix as the fallback for
  // outcomes the sport parsers recognize but don't fully destructure.
  if (parsed.spread || parsed.category.endsWith('-spread')) return 'spread';
  if (parsed.total || parsed.category.endsWith('-total')) return 'total';
  return 'moneyline';
}
